import { useEffect, useRef, useState } from 'react';
import useLocalStorage from '../../hooks/useLocalStorage';
import styles from './QuestionSpeaker.module.css';

const protocol = window?.location.protocol || 'https:';

export const QuestionSpeaker = ({ authorId }) => {
  const [msgs, setMsgs] = useLocalStorage('msgs', []);
  const [value, setValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const msgsRef = useRef(null);

  const send = async (e) => {
    e.preventDefault();

    if (!value) {
      return;
    }

    setIsLoading(true);
    const newMsg = { content: value, timestamp: Date.now() };

    try {
      const response = await fetch(
        `${protocol}//wh.iactive.pro/api/getter/landing`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: value,
            authorId,
            date: Date.now(),
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status}`);
      }

      const data = await response.json();

      setMsgs((prev) => [...prev, newMsg]);
      setValue('');
    } catch (error) {
      console.error('Ошибка запроса:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeTextarea = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    if (msgsRef.current) {
      msgsRef.current.scrollTo({
        top: msgsRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [msgs]);

  return (
    <div className={styles.questionSpeaker}>
      <div className={styles.questionsBlock}>
        <div className={styles.title}>ЗАДАЙТЕ ВОПРОС СПИКЕРУ</div>
        <div className={styles.subTitle}>
          Введите имя спикера, которому адресован вопрос
        </div>

        {msgs && msgs.length > 0 && (
          <ul className={styles.msgList} ref={msgsRef}>
            {msgs.map((m, idx) => (
              <li key={idx} className={styles.msg}>
                {m.content}
              </li>
            ))}
          </ul>
        )}
      </div>

      <form className={styles.sendBlock} onSubmit={send}>
        <textarea
          value={value}
          onChange={onChangeTextarea}
          placeholder="Имя спикера и вопрос"
          name="questionSpeaker"
          id="questionSpeaker"
        />
        <button className={styles.sendBtn} disabled={isLoading} />
      </form>
    </div>
  );
};
